import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { FieldValidation } from "svelte-forms2";

type Validator = (value: any) => FieldValidation | Promise<FieldValidation>;

function lenientEmailValidator(): Validator {
  return (value: string) => {
    return {
      valid: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      name: "email",
    };
  };
}

function validateEmailApi(): Validator {
  return async (email: string) => {
    let valid = !!email;

    if (valid) {
      valid = await HttpPromise({
        method: "GET",
        url: "/api/validations/check_email",
        data: { email },
      }).then(res => res.valid);
    }

    return {
      valid,
      name: "not_an_email",
    };
  };
}

async function email(val: string) {
  let result = await HttpPromise({
    method: "GET",
    url: "/api/validations/check_email",
    data: {
      email: val,
    },
  });

  return {
    valid: result.valid,
    name: "email",
  };
}

async function emailOrEmpty(val) {
  if (!Boolean(val)) {
    return {
      valid: true,
      name: "email",
    };
  }

  return email(val);
}

function lenientEmail(val: string) {
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  return {
    valid: valid,
    name: "email",
  };
}

export { email, emailOrEmpty, lenientEmail, lenientEmailValidator, validateEmailApi };
